import React, { useState, useEffect } from "react";
import axios from "axios";
import { connect } from "react-redux";

import { setAlert } from "../redux/actions/alerts";
import styles from '../styles/Components/ClearCacheButton.module.css';
import RoundCheckInput from "./Administration/RolesPage/RoundCheckInput";
import Modal from "./Shared/Modal";

function ClearCacheButton({ setAlert }) {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [chosenSite, setChosenSite] = useState('DPS')
    const [checkedOptions, setCheckedOptions] = useState([])
    const [disabledButton, setDisabledButton] = useState(false)

    const [count, setCount] = useState(30)

    const sites = ['DPS']

    const dpsCacheOptions = [
        { id: 1, label: 'Clear server side cache' },
        { id: 2, label: 'Refresh All Cache' },
        { id: 3, label: 'Refresh Category Cache' },
        { id: 4, label: 'Refresh Product Cache' },
        { id: 5, label: 'Refresh Manufacturer Cache' },
    ]

    const dpsRefreshOptions = [
        { id: 29, label: 'Refresh Top Products' },
    ]

    const duplicateRevalidation = {
        20: 12,
        21: 12,
        22: 9,
        23: 11,
        24: 15,
        25: 7
    }

    const handleClose = () => {
        // setChosenSite('')
        setCheckedOptions([]);
        setDialogOpen(false);
    };

    const handleDialogOpen = (e) => {
        setDialogOpen(true);
    };

    const baseUrl = process.env.REACT_APP_BASE_URL;

    const handleCheck = (e, option) => {
        if (!e) return;
        if (e.target.checked === true) {
            if (option === 6 || option === 2 || option === 19) {
                if (option === 2 && checkedOptions.includes(1)) {
                    setCheckedOptions([1, 2])
                } else if (option === 6) {
                    setCheckedOptions([option])
                } else {
                    const dxpRevalidateIds = [20, 21, 22, 23, 24, 25, 26, 27]
                    const clearedOptions = checkedOptions.filter(checked => !dxpRevalidateIds.includes(checked))
                    setCheckedOptions([...clearedOptions, option])
                }
            } else {
                setCheckedOptions(prevCheckedOptions => [...prevCheckedOptions, option])
            }
        } else {
            const filteredOptions = checkedOptions.filter(el => el !== option);
            setCheckedOptions(filteredOptions)
        }
    }

    const chooseRoute = async (option, submitOption) => {

        switch (option) {
            case 1:
                await axios.get(`https://api.dentalproductshopper.com/api/cache/clear`);
                return
            case 2:
                await axios.get(`${baseUrl}/api/expanded/all`);
                return
            case 3:
                await axios.get(`${baseUrl}/api/expanded/category`);
                return
            case 4:
                await axios.get(`${baseUrl}/api/expanded/products`);
                return
            case 5:
                await axios.get(`${baseUrl}/api/expanded/manufacturers`);
                return
            
            case 29:
                await axios.get(`${baseUrl}/api/topvieweds/newtopviewed`);
                return
        }


    }

    const disableButton = () => {
        setDisabledButton(true)
        let i = 30
        const countDown = setInterval(() => {
            i--
            if (i <= 0) {
                setDisabledButton(false)
                setCount(30)
                i = 30
                clearInterval(countDown)
            }
            setCount(prevCount => prevCount - 1);
        }, 500)
    }

    const handleSubmit = async (submitOption) => {
        disableButton()
        try {
            for (let option of checkedOptions) {
                if (checkedOptions.includes(duplicateRevalidation[option])) {
                    continue
                }
                await chooseRoute(option, submitOption);
            }
            setAlert('Cache updated', 'success')

        } catch (err) {
            console.error(err)
            setAlert('Error updating cache', 'danger')
        }
        handleClose();
        // getExpandedData()
    }
    
    return (
        <>
            <button className={styles.refresh_cache_button} onClick={(e) => handleDialogOpen(e)}>Refresh Website Caches</button>

            <Modal
                open={dialogOpen} 
                setOpen={handleClose}
                component={

                    <div className={styles.refresh_cache_form}>
                        <p className={styles.refresh_cache_header}>Refresh Cache</p>
                        
                        <div className={styles.refresh_cache_content}>

                            {chosenSite === 'DPS' &&
                                <>
                                    {dpsCacheOptions.map((option, i) => (
                                        <RoundCheckInput
                                            key={`option-${i}`}
                                            checked={checkedOptions.includes(option.id)}
                                            value={checkedOptions.includes(option.id)}
                                            label={option.label}
                                            id={option.label}
                                            handleChange={(e) => handleCheck(e, option.id)}
                                            disabled={checkedOptions.includes(2) && (option.id !== 2 && option.id !== 1)}
                                        />
                                    ))}
                                    <div>
                                        <div className={styles.refresh_cache_divider} />

                                    </div>
                                    {dpsRefreshOptions.map((option, i) => (
                                        <RoundCheckInput
                                            key={`revalidate-option-${i}`}
                                            checked={checkedOptions.includes(option.id)}
                                            value={checkedOptions.includes(option.id)}
                                            label={option.label}
                                            id={option.label}
                                            handleChange={(e) => handleCheck(e, option.id)}
                                            disabled={checkedOptions.includes(2) && (option.id !== 2 && option.id !== 1)}
                                        />
                                    ))}

                                </>
                            }
                        </div>
                        {chosenSite !== '' &&
                            <div className={styles.refresh_cache_button_container}>
                                <button className={styles.refresh_cache_submit_button} disabled={disabledButton} onClick={() => handleSubmit('submit')}>{disabledButton ? count : 'Submit'}</button>

                                
                            </div>
                        }      
                    </div>
                }
            />
        

        </>
    );
}



const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
    setAlert,

})(ClearCacheButton);